import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import type { FtueState } from './types';
import type { TourStep, FtueTour } from 'types';
import type { Props } from '../../components/Ftue/FtueCalloutContainer.js';
import { hasClickAwayOnly } from '../user';

export const getTourStepByName = (state: FtueState, props: Props): TourStep => {
  const tour = state.allTours[props.name];
  if (!tour) return undefined;
  const steps = tour.steps || [];
  return steps.find(s => s.name === props.step);
};

export function getCurrentStep({ allTours, queuedTours, currentStep }: FtueState): TourStep | any {
  const currentTour = allTours[queuedTours[0]];
  if (isEmpty(queuedTours) || !currentTour) return {};

  const steps = currentTour.steps || [];
  return steps[currentStep] || {};
}

const getNameFor =
  property =>
  (_, props): string =>
    props[property];

export const getViewedTour = (state: FtueState, props: Props): FtueTour => {
  const tour = state.allTours ? state.allTours[props.name] : undefined;
  if (
    tour &&
    tour.id !== undefined &&
    state.toursViewed &&
    state.toursViewed[tour.id] !== undefined
  ) {
    return state.toursViewed[tour.id];
  }
  return state.toursViewed ? state.toursViewed[props.name] : undefined;
};

export const isUnviewedCallout = createSelector(
  [getViewedTour, getTourStepByName],
  (viewedTour, tourStep) => {
    if (!viewedTour) return true;
    const viewedSteps = viewedTour.tourStepSettings || [];

    // tourStepSettings only tracks tourStepId, so match against the resolved step's id
    const foundStep = viewedSteps.find(s => s.tourStepId === tourStep?.id);

    return !foundStep || (foundStep && !foundStep.viewed);
  }
);

export const hideCallout = createSelector(
  [state => state, getNameFor('name')],
  ({ auth, ftue }, name) => !auth.isAuthenticated || !ftue.allTours[name]
);

export const isCurrentStep = createSelector(
  [getCurrentStep, getTourStepByName],
  (currentStep, step) => {
    return currentStep?.id === step?.id;
  }
);

export const showFtueCallout = createSelector(
  [isCurrentStep, isUnviewedCallout],
  (isCurrentStep, isUnviewedCallout) => {
    return isCurrentStep && isUnviewedCallout;
  }
);

export const showTourOverlay: any = createSelector([state => state] as any, (state, params) => {
  return (
    state.ui.globalMenuTutorialOpen &&
    !hasClickAwayOnly(state, params) &&
    state.user.settings?.licensing?.viewedWelcome === true
  );
});
